import { useMutation, useQuery } from "@tanstack/react-query"
import { InvitationLock, PostInvitationLockBody } from "../types/types"
import { apiFetchProtected } from "../utils/api"

const feetchInvitationLocks = async (): Promise<Array<InvitationLock>> =>
  apiFetchProtected<Array<InvitationLock>>(
    "/secretaries/users/invitation_locks",
    {}
  ).then((data) => {
    return [
      ...data.sort((a, b) => {
        const a_date = new Date(a.created_at)
        const b_date = new Date(b.created_at)
        return b_date.valueOf() - a_date.valueOf()
      })
    ]
  })

export const useInvitationLocksQuery = <TData = Array<InvitationLock>>(
  select?: (data: Array<InvitationLock>) => TData
) => {
  return useQuery({
    queryKey: ["invitation_locks"],
    queryFn: () => feetchInvitationLocks(),
    select
  })
}

export const usePostInvitation = () => {
  return useMutation({
    mutationFn: (invitation: PostInvitationLockBody) =>
      apiFetchProtected("/secretaries/users/invitation_locks", {
        method: "POST",
        body: invitation
      }),
    onError: (error) => {
      console.error("Error:", error)
    },
    onSuccess: (data, variables) => {
      return
    }
  })
}
